import {DATE_CHANGE} from './types';

export default function DateChange(val) {
    return {
        type: DATE_CHANGE,
        date: val,
        meta: {dialog: 'Ask confirm!!'}
    }
}


/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/DateChange.js
 **/